import React, { useEffect, useState, useMemo } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useAuth } from "../../AuthContext";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputMask } from "primereact/inputmask";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { Chip } from "primereact/chip";

import "primeicons/primeicons.css";

import {
  FaUser,
  FaCalendar,
  FaCalendarCheck,
  FaShoppingCart,
  FaFileInvoiceDollar,
  FaIdCard,
  FaPhone,
  FaChartLine,
  FaBuilding,
  FaHospitalUser,
  FaUserFriends,
  FaList,
  FaCashRegister,
  FaClipboardList,
  FaUserCircle,
  FaEnvelope,
  FaShieldAlt,
  FaEye,
  FaEyeSlash,
  FaCalendarAlt,
  FaCubes,
  FaInfoCircle,
  FaUserMd,
} from "react-icons/fa";

const Usuarios = () => {
  const { user } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [usuarios, setUsuarios] = useState([]);

  const [visibleNovoUsuario, setVisibleNovoUsuario] = useState(false);
  const [visibleEditarUsuario, setVisibleEditarUsuario] = useState(false);

  const [usuarioEditando, setUsuarioEditando] = useState([]);

  //Cadastro
  const [login, setLogin] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [tipo, setTipo] = useState("");
  const [ativo, setAtivo] = useState(false);
  const [mostrarSenha, setMostrarSenha] = useState(false);

  // Estados para os dialogs de confirmação
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const modulosDisponiveis = [
    { nome: "Reservas", icone: <FaCalendarAlt /> },
    { nome: "Agenda", icone: <FaCalendarCheck /> },
    { nome: "Caixa", icone: <FaCashRegister /> },
    { nome: "Despesas", icone: <FaFileInvoiceDollar /> },
    { nome: "Relatórios", icone: <FaChartLine /> },
    { nome: "Empresas", icone: <FaBuilding /> },
    { nome: "Pacientes", icone: <FaUserFriends /> },
    { nome: "Profissionais", icone: <FaUserMd /> },
    { nome: "Servicos", icone: <FaList /> },
    { nome: "Pedidos", icone: <FaClipboardList /> },
    { nome: "Usuarios", icone: <FaUser /> },
  ];

  const [modulosSelecionados, setModulosSelecionados] = useState(() => {
    const modulosInicial = {};
    modulosDisponiveis.forEach((moduloObj) => {
      modulosInicial[moduloObj.nome] = {
        visualizar: false,
        editar: false,
      };
    });
    return modulosInicial;
  });

  //Filtro
  const [mostrarFiltroUsuario, setMostrarFiltroUsuario] = useState(false);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroCpf, setFiltroCpf] = useState("");
  const [filtroTelefone, setFiltroTelefone] = useState("");
  const [filtroEmail, setFiltroEmail] = useState("");

  useEffect(() => {
    fetchUsuarios();
  }, []);

  // usuarios filtrados e ordenados
  const usuariosFiltrados = useMemo(() => {
    return usuarios.filter((usuario) => {
      // Verifica filtro de nome (se filtroNome não estiver vazio)
      const nomeMatch =
        !filtroNome ||
        usuario.nome?.toLowerCase().includes(filtroNome.toLowerCase());

      // Verifica filtro de CPF (se filtroCpf não estiver vazio)
      const cpfMatch =
        !filtroCpf ||
        usuario.cpf?.toLowerCase().includes(filtroCpf.toLowerCase());

      // Verifica filtro de telefone (se filtroTelefone não estiver vazio)
      const telefoneMatch =
        !filtroTelefone ||
        usuario.telefone?.toLowerCase().includes(filtroTelefone.toLowerCase());

      // Verifica filtro de email (se filtroEmail não estiver vazio)
      const emailMatch =
        !filtroEmail ||
        usuario.email?.toLowerCase().includes(filtroEmail.toLowerCase());

      // Retorna true apenas se TODOS os filtros ativos corresponderem
      return nomeMatch && cpfMatch && telefoneMatch && emailMatch;
    });
  }, [usuarios, filtroNome, filtroCpf, filtroTelefone, filtroEmail]);

  const fetchUsuarios = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/usuarios",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Erro ao buscar usuarios");
      }

      const data = await response.json();

      console.log("usuarios = ", data.data);

      if (data.success && Array.isArray(data.data)) {
        setUsuarios(data.data);
        setError(null);
      } else {
        setUsuarios([]);
        setError("Nenhum usuario encontrado.");
      }
    } catch (error) {
      setError(error.message);
      setUsuarios([]);
    } finally {
      setLoading(false);
    }
  };

  const resetarCampos = () => {
    setNome("");
    setEmail("");
    setLogin("");
    setSenha("");
    setTipo("");
    setAtivo(true);

    const modulosInicial = {};
    modulosDisponiveis.forEach((moduloObj) => {
      modulosInicial[moduloObj.nome] = {
        visualizar: false,
        editar: false,
      };
    });
    setModulosSelecionados(modulosInicial);
  };

  const handleSalvar = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      // Verificação de força da senha (igual ao backend)
      if (senha.length < 5 || !/[A-Za-z]/.test(senha) || !/[0-9]/.test(senha)) {
        alert(
          "A senha deve ter pelo menos 5 caracteres, com pelo menos uma letra e um número",
        );
        setLoading(false);
        return;
      }

      const usuarioData = {
        user_login: login,
        user_nicename: nome,
        user_email: email,
        user_pass: senha,
        modulos: modulosSelecionados,
      };

      const response = await fetch(
        "https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/cadastrar-usuario",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(usuarioData),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        // Tenta obter mensagem de erro do backend
        const errorMessage =
          data?.message || data?.error || "Falha ao cadastrar usuário";
        throw new Error(errorMessage);
      }

      setDialogMessage("Usuário cadastrado com sucesso!");
      setShowSuccessDialog(true);

      fetchUsuarios();

      setVisibleNovoUsuario(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro detalhado ao salvar:", err);
      // Formata melhor a mensagem de erro
      let errorMsg = err.message;

      // Se for uma resposta JSON inválida
      if (err.message.includes("JSON")) {
        errorMsg = "Erro na comunicação com o servidor";
      }

      setDialogMessage(errorMsg);
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEditar = async (usuarioId) => {
    setLoading(true);
    setError(null);

    try {
      if (!user?.token) {
        throw new Error("Usuário não autenticado. Faça login novamente.");
      }

      if (!login || !nome || !email) {
        setDialogMessage("Preencha todos os campos obrigatórios");
        setShowErrorDialog(true);
        return;
      }

      const usuarioData = {
        id: usuarioId,
        user_login: login,
        user_nicename: nome,
        user_email: email,
        modulos: modulosSelecionados,
      };

      console.log("usuarioData = ", usuarioData);

      const response = await fetch(
        `https://helder.cantarellisolucoes.com.br/wp-json/custom/v1/editar-usuario`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
            Accept: "application/json",
          },
          body: JSON.stringify(usuarioData),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        // Tenta obter mensagem de erro do backend
        const errorMessage =
          data?.message || data?.error || "Falha ao atualizar o usuário";
        throw new Error(errorMessage);
      }

      setDialogMessage("Usuário atualizado com sucesso!");
      setShowSuccessDialog(true);

      fetchUsuarios();

      setVisibleEditarUsuario(false);
      resetarCampos();
    } catch (err) {
      console.error("Erro na edição:", err);
      setDialogMessage(
        err.message.includes("não encontrada")
          ? "Usuário não encontrado ou já removida"
          : err.message,
      );
      setShowErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const bodyTipoTemplate = (tipo) => {
    switch (tipo) {
      case "contributor":
        return "Colaborador";
      case "administrator":
        return "Administrador";
      case "padrao":
        return "Padrão";
      default:
        return "Não informado";
    }
  };

  const toggleModulo = (moduloNome, permissao) => {
    setModulosSelecionados((prev) => ({
      ...prev,
      [moduloNome]: {
        ...prev[moduloNome],
        [permissao]: !prev[moduloNome]?.[permissao],
      },
    }));
  };

  {
    /* Return Principal */
  }
  return (
    <div
      style={{
        fontFamily: "'Rajdhani', sans-serif",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      {/* Dialog de Sucesso */}
      <Dialog
        visible={showSuccessDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowSuccessDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#22C55E",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-check-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            icon="pi pi-check"
            onClick={() => setShowSuccessDialog(false)}
            className="p-button-success"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog de Erro */}
      <Dialog
        visible={showErrorDialog}
        style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
        onHide={() => setShowErrorDialog(false)}
        draggable={false}
        closable={false}
        header={null}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            padding: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              color: "#EF4444",
              fontSize: "2.2rem",
            }}
          >
            <i
              className="pi pi-times-circle"
              style={{ fontSize: "2.5rem" }}
            ></i>
          </div>
          <p
            style={{
              textAlign: "center",
              fontSize: "1rem",
              margin: 0,
              color: "#374151",
            }}
          >
            {dialogMessage}
          </p>
          <Button
            label="OK"
            onClick={() => setShowErrorDialog(false)}
            className="p-button-danger"
            style={{
              padding: "6px 20px",
              fontWeight: "bold",
              fontSize: "0.9rem",
            }}
          />
        </div>
      </Dialog>

      {/* Dialog Novo */}
      <Dialog
        visible={visibleNovoUsuario}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleNovoUsuario(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUser style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  ADICIONAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  USUÁRIO
                </div>
              </div>
            </div>
          </div>
        }
      >
        <>
          {/* Formulário em Cards */}
          <div style={{ padding: "20px 0" }}>
            {/* 1ª Linha - Nome e Login */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Nome */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #3498DB",
                    }}
                  >
                    <FaUser style={{ color: "#3498DB", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Nome *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Nome completo"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      fontSize: "0.9rem",
                    }}
                  />
                </div>
              </div>

              {/* Card Login */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #E67E22",
                    }}
                  >
                    <FaUser style={{ color: "#E67E22", fontSize: "0.9rem" }} />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Login *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="Login do usuário"
                    value={login}
                    onChange={(e) => setLogin(e.target.value.toLowerCase())}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      fontSize: "0.9rem",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 2ª Linha - Email e Senha */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {/* Card Email */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #D35400",
                    }}
                  >
                    <FaEnvelope
                      style={{ color: "#D35400", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Email *
                    </span>
                  </div>
                  <InputText
                    className="p-inputtext-sm"
                    placeholder="email@usuario.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    style={{
                      width: "100%",
                      height: "35px",
                      fontFamily: "'Rajdhani', sans-serif",
                      border: "1px solid #dee2e6",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      fontSize: "0.9rem",
                    }}
                  />
                </div>
              </div>

              {/* Card Senha */}
              <div
                style={{
                  backgroundColor: "#fafafa",
                  border: "1px solid #e8e8e8",
                  padding: "15px",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      paddingBottom: "5px",
                      borderBottom: "2px solid #2980B9",
                    }}
                  >
                    <FaShieldAlt
                      style={{ color: "#2980B9", fontSize: "0.9rem" }}
                    />
                    <span
                      style={{
                        fontWeight: "600",
                        color: "#2c3e50",
                        fontSize: "0.95rem",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Senha *
                    </span>
                  </div>
                  <div style={{ position: "relative", width: "100%" }}>
                    <InputText
                      type={mostrarSenha ? "text" : "password"}
                      className="p-inputtext-sm"
                      placeholder="*****"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        paddingRight: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    />
                    <span
                      onClick={() => setMostrarSenha(!mostrarSenha)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#7f8c8d",
                        fontSize: "0.9rem",
                      }}
                    >
                      {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Mensagem de validação da senha */}
            <div
              style={{
                backgroundColor: "#e8f4f8",
                border: "1px solid #b3e0f2",
                borderRadius: "4px",
                padding: "8px 12px",
                margin: "10px 25px",
                fontSize: "0.75rem",
                color: "#2c3e50",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <FaInfoCircle
                style={{
                  marginRight: "5px",
                  fontSize: "0.8rem",
                  color: "#3498DB",
                }}
              />
              A senha deve ter pelo menos 5 caracteres, com pelo menos uma letra
              e um número
            </div>

            {/* Card de Módulos (se aplicável) */}
            {usuarioEditando.tipo !== "administrator" &&
              user.tipo === "administrator" && (
                <div
                  style={{
                    display: "grid",
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: "5px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    {/* Cabeçalho do Card */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498DB",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <FaCubes
                          style={{ color: "#3498DB", fontSize: "1rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "1rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Permissões de Módulos
                        </span>
                      </div>
                    </div>

                    {/* Instrução */}
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: "#7f8c8d",
                        marginBottom: "5px",
                      }}
                    >
                      Selecione os módulos que este usuário poderá acessar:
                    </div>

                    {/* Grid de Módulos */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(100px, 1fr))",
                        gap: "5px",
                      }}
                    >
                      {modulosDisponiveis.map((moduloObj) => (
                        <div
                          key={moduloObj.nome}
                          style={{
                            border: "1px solid #e8e8e8",
                            padding: "8px",
                            borderRadius: "5px",
                            background: "#fff",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {/* Cabeçalho do Módulo */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              marginBottom: "5px",
                              fontSize: "0.85rem",
                              fontWeight: "600",
                              borderBottom: "1px solid #3498DB",
                              color: "#2c3e50",
                            }}
                          >
                            <span
                              style={{ color: "#3498DB", fontSize: "0.9rem" }}
                            >
                              {moduloObj.icone}
                            </span>
                            {moduloObj.nome}
                          </div>

                          {/* Permissões */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                            }}
                          >
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                cursor: "pointer",
                              }}
                            >
                              <Checkbox
                                checked={
                                  modulosSelecionados[moduloObj.nome]
                                    ?.visualizar || false
                                }
                                onChange={() =>
                                  toggleModulo(moduloObj.nome, "visualizar")
                                }
                                style={{ transform: "scale(0.9)" }}
                              />
                              <span
                                style={{ fontSize: "0.8rem", color: "#495057" }}
                              >
                                Visualizar
                              </span>
                            </label>

                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                cursor: "pointer",
                              }}
                            >
                              <Checkbox
                                checked={
                                  modulosSelecionados[moduloObj.nome]?.editar ||
                                  false
                                }
                                onChange={() =>
                                  toggleModulo(moduloObj.nome, "editar")
                                }
                                style={{ transform: "scale(0.9)" }}
                              />
                              <span
                                style={{ fontSize: "0.8rem", color: "#495057" }}
                              >
                                Editar
                              </span>
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
          </div>

          {/* Botão Fechar */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              onClick={() => {
                setVisibleNovoUsuario(false);
                resetarCampos();
              }}
              className="p-button-outlined p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "120px",
                borderColor: "#dee2e6",
                color: "#495057",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading}
            />
            <Button
              label={loading ? "SALVANDO..." : "CADASTRAR USUÁRIO"}
              icon="pi pi-check"
              onClick={handleSalvar}
              className="p-button-success p-button-sm"
              style={{
                outline: "none",
                boxShadow: "none",
                padding: "8px 24px",
                minWidth: "160px",
                fontWeight: "500",
                fontSize: "0.875rem",
              }}
              disabled={loading || !login || !nome || !email || !senha}
              loading={loading}
            />
          </div>
        </>
      </Dialog>

      {/* Dialog Editar */}
      <Dialog
        visible={visibleEditarUsuario}
        style={{
          width: "90vw",
          maxWidth: "768px",
          fontFamily: "'Rajdhani', sans-serif",
        }}
        onHide={() => {
          if (!loading) {
            resetarCampos();
            setVisibleEditarUsuario(false);
          }
        }}
        draggable={false}
        header={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "-45px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ marginRight: "8px", paddingLeft: "8px" }}>
                <FaUser style={{ fontSize: "2.4rem", color: "#B83732" }} />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <div
                  style={{
                    fontSize: "0.9rem",
                    width: "100%",
                    letterSpacing: "1px",
                  }}
                >
                  EDITAR
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    marginTop: "-10px",
                  }}
                >
                  USUÁRIO
                </div>
              </div>
            </div>
          </div>
        }
      >
        {usuarioEditando && (
          <>
            {/* Formulário em Cards */}
            <div style={{ padding: "20px 0" }}>
              {/* 1ª Linha - Nome e Login */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* Card Nome */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #3498DB",
                      }}
                    >
                      <FaUser
                        style={{ color: "#3498DB", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Nome *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="Nome completo"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    />
                  </div>
                </div>

                {/* Card Login */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #E67E22",
                      }}
                    >
                      <FaUser
                        style={{ color: "#E67E22", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Login *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="Login do usuário"
                      value={login}
                      onChange={(e) => setLogin(e.target.value.toLowerCase())}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* 2ª Linha - Email e Senha */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                  gap: "10px",
                  marginBottom: "10px",
                }}
              >
                {/* Card Email */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #D35400",
                      }}
                    >
                      <FaEnvelope
                        style={{ color: "#D35400", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Email *
                      </span>
                    </div>
                    <InputText
                      className="p-inputtext-sm"
                      placeholder="email@usuario.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        width: "100%",
                        height: "35px",
                        fontFamily: "'Rajdhani', sans-serif",
                        border: "1px solid #dee2e6",
                        borderRadius: "4px",
                        padding: "8px 12px",
                        fontSize: "0.9rem",
                      }}
                    />
                  </div>
                </div>

                {/* Card Senha */}
                <div
                  style={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #e8e8e8",
                    padding: "15px",
                    borderRadius: "6px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        paddingBottom: "5px",
                        borderBottom: "2px solid #2980B9",
                      }}
                    >
                      <FaShieldAlt
                        style={{ color: "#2980B9", fontSize: "0.9rem" }}
                      />
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#2c3e50",
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                        }}
                      >
                        Senha *
                      </span>
                    </div>
                    <div style={{ position: "relative", width: "100%" }}>
                      <InputText
                        type={mostrarSenha ? "text" : "password"}
                        className="p-inputtext-sm"
                        placeholder="*****"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        style={{
                          width: "100%",
                          height: "35px",
                          paddingRight: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                          padding: "8px 12px",
                          fontSize: "0.9rem",
                        }}
                      />
                      <span
                        onClick={() => setMostrarSenha(!mostrarSenha)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#7f8c8d",
                          fontSize: "0.9rem",
                        }}
                      >
                        {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mensagem de validação da senha */}
              <div
                style={{
                  backgroundColor: "#e8f4f8",
                  border: "1px solid #b3e0f2",
                  borderRadius: "4px",
                  padding: "8px 12px",
                  margin: "10px 25px",
                  fontSize: "0.75rem",
                  color: "#2c3e50",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <FaInfoCircle
                  style={{
                    marginRight: "5px",
                    fontSize: "0.8rem",
                    color: "#3498DB",
                  }}
                />
                A senha deve ter pelo menos 5 caracteres, com pelo menos uma
                letra e um número
              </div>

              {/* Card de Módulos (se aplicável) */}
              {usuarioEditando.tipo !== "administrator" &&
                user.tipo === "administrator" && (
                  <div
                    style={{
                      display: "grid",
                      backgroundColor: "#fafafa",
                      border: "1px solid #e8e8e8",
                      padding: "15px",
                      borderRadius: "6px",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(280px, 1fr))",
                      gap: "5px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      {/* Cabeçalho do Card */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FaCubes
                            style={{ color: "#3498DB", fontSize: "1rem" }}
                          />
                          <span
                            style={{
                              fontWeight: "600",
                              color: "#2c3e50",
                              fontSize: "1rem",
                              letterSpacing: "0.3px",
                            }}
                          >
                            Permissões de Módulos
                          </span>
                        </div>
                      </div>

                      {/* Instrução */}
                      <div
                        style={{
                          fontSize: "0.85rem",
                          color: "#7f8c8d",
                          marginBottom: "5px",
                        }}
                      >
                        Selecione os módulos que este usuário poderá acessar:
                      </div>

                      {/* Grid de Módulos */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(100px, 1fr))",
                          gap: "5px",
                        }}
                      >
                        {modulosDisponiveis.map((moduloObj) => (
                          <div
                            key={moduloObj.nome}
                            style={{
                              border: "1px solid #e8e8e8",
                              padding: "8px",
                              borderRadius: "5px",
                              background: "#fff",
                              transition: "all 0.2s ease",
                            }}
                          >
                            {/* Cabeçalho do Módulo */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                marginBottom: "5px",
                                fontSize: "0.85rem",
                                fontWeight: "600",
                                borderBottom: "1px solid #3498DB",
                                color: "#2c3e50",
                              }}
                            >
                              <span
                                style={{ color: "#3498DB", fontSize: "0.9rem" }}
                              >
                                {moduloObj.icone}
                              </span>
                              {moduloObj.nome}
                            </div>

                            {/* Permissões */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "5px",
                              }}
                            >
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  cursor: "pointer",
                                }}
                              >
                                <Checkbox
                                  checked={
                                    modulosSelecionados[moduloObj.nome]
                                      ?.visualizar || false
                                  }
                                  onChange={() =>
                                    toggleModulo(moduloObj.nome, "visualizar")
                                  }
                                  style={{ transform: "scale(0.9)" }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#495057",
                                  }}
                                >
                                  Visualizar
                                </span>
                              </label>

                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  cursor: "pointer",
                                }}
                              >
                                <Checkbox
                                  checked={
                                    modulosSelecionados[moduloObj.nome]
                                      ?.editar || false
                                  }
                                  onChange={() =>
                                    toggleModulo(moduloObj.nome, "editar")
                                  }
                                  style={{ transform: "scale(0.9)" }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem",
                                    color: "#495057",
                                  }}
                                >
                                  Editar
                                </span>
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
            </div>

            {/* Botão Fechar */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "15px",
                flexWrap: "wrap",
              }}
            >
              <Button
                label="CANCELAR"
                icon="pi pi-times"
                onClick={() => {
                  setVisibleEditarUsuario(false);
                  resetarCampos();
                }}
                className="p-button-outlined p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "120px",
                  borderColor: "#dee2e6",
                  color: "#495057",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
                disabled={loading}
              />
              <Button
                label={loading ? "SALVANDO..." : "SALVAR ALTERAÇÕES"}
                icon="pi pi-check"
                onClick={() => handleEditar(usuarioEditando.id)}
                className="p-button-success p-button-sm"
                style={{
                  outline: "none",
                  boxShadow: "none",
                  padding: "8px 24px",
                  minWidth: "160px",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                }}
                disabled={loading || !login || !nome || !email}
                loading={loading}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* Barra superior vermelha */}
      <div
        style={{
          backgroundColor: "#B83732",
          height: "40px",
          minHeight: "40px",
          width: "100%",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
          fontWeight: "bold",
          position: "fixed",
          zIndex: 1, 
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {/* lado esquerdo */}
        <div></div>

        {/* Centro */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            icon="pi pi-refresh"
            className="icon-button-titulo"
            onClick={fetchUsuarios}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon={mostrarFiltroUsuario ? "pi pi-filter-slash" : "pi pi-filter"}
            className="icon-button-titulo"
            onClick={() => {
              setMostrarFiltroUsuario(!mostrarFiltroUsuario);
            }}
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            outlined
          />
          <Button
            icon="pi pi-plus"
            className="icon-button-titulo"
            onClick={() => {
              if (
                user.tipo === "administrator" ||
                user.modulos?.Usuarios?.editar
              ) {
                setVisibleNovoUsuario(true);
                resetarCampos();
              }
            }}
            disabled={
              !(user.tipo === "administrator" || user.modulos?.Usuarios?.editar)
            }
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              color: "#ffffff",
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              opacity:
                user.tipo === "administrator" || user.modulos?.Usuarios?.editar
                  ? 1
                  : 0.4,
              cursor:
                user.tipo === "administrator" || user.modulos?.Usuarios?.editar
                  ? "pointer"
                  : "not-allowed",
            }}
            outlined
          />
        </div>

        {/* lado direito */}
        <div></div>
      </div>

      {/* Conteúdo abaixo da barra */}
      <div style={{ flex: 1, padding: "50px 10px" }}>
        {/* MOSTRAR RESERVAS DO DIA SELECIONADO - SEMPRE VISÍVEL */}
        <div style={{ borderRadius: "8px", padding: "0 15px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderBottom: "1px solid #E2E8F0",
            }}
          >
            <div style={{ marginTop: "7px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  gap: "5px",
                }}
              >
                <FaUser style={{ color: "#B83732", fontSize: "1.2rem" }} />
                <h3 style={{ margin: 0, color: "#424242" }}>USUÁRIOS</h3>
              </div>
            </div>
          </div>

          {/* InputSwitch */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              marginBottom: "30px",
            }}
          ></div>

          {/* Filtros*/}
          {mostrarFiltroUsuario && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "8px",
                  padding: "10px 8px",
                  border: "1px solid #dee2e6",
                  backgroundColor: "#fff",
                  width: "95%",
                  maxWidth: "920px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                {/* 1ª Linha - Nome e CPF */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(200px, 1fr))",
                    gap: "10px",
                  }}
                >
                  {/* Card Nome */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #3498DB",
                        }}
                      >
                        <FaUserMd
                          style={{ color: "#3498DB", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Nome{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Nome do usuário"
                        value={filtroNome}
                        onChange={(e) => setFiltroNome(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card CPF */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #E67E22",
                        }}
                      >
                        <FaIdCard
                          style={{ color: "#E67E22", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          CPF{" "}
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="CPF do usuário"
                        value={filtroCpf}
                        onChange={(e) => setFiltroCpf(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Telefone */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #2980b9",
                        }}
                      >
                        <FaPhone
                          style={{ color: "#2980b9", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Telefone
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Telefone do usuário"
                        value={filtroTelefone}
                        onChange={(e) => setFiltroTelefone(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>

                  {/* Card Email */}
                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          paddingBottom: "5px",
                          borderBottom: "2px solid #d35400",
                        }}
                      >
                        <FaEnvelope
                          style={{ color: "#d35400", fontSize: "0.9rem" }}
                        />
                        <span
                          style={{
                            fontWeight: "600",
                            color: "#2c3e50",
                            fontSize: "0.95rem",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Email
                        </span>
                      </div>
                      <InputText
                        className="p-inputtext-sm"
                        placeholder="Email do usuário"
                        value={filtroEmail}
                        onChange={(e) => setFiltroEmail(e.target.value)}
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "100%",
                          height: "35px",
                          fontFamily: "'Rajdhani', sans-serif",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Grids */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 8px",
            }}
          >
            {usuariosFiltrados.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "2px dashed #e8e8e8",
                }}
              >
                <FaUser
                  style={{
                    fontSize: "3rem",
                    color: "#B83732",
                    marginBottom: "15px",
                    opacity: 0.5,
                  }}
                />
                <h3
                  style={{
                    color: "#2c3e50",
                    margin: "0 0 10px 0",
                    fontSize: "1.2rem",
                    fontWeight: "600",
                  }}
                >
                  Nenhum usuário encontrado
                </h3>
              </div>
            ) : (
              <div
                className="grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", // Alterado para 280px
                  gap: "15px",
                  alignItems: "stretch",
                }}
              >
                {usuariosFiltrados.map((item, idx) => (
                  <div key={idx}>
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        padding: "12px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      {/* Informações do Paciente */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          marginBottom: "5px",
                          paddingBottom: "5px",
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        <FaUserCircle
                          style={{
                            fontSize: "2.5rem",
                            color: "#D65A55",
                            flexShrink: 0,
                          }}
                        />
                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              fontSize: "1rem",
                              fontWeight: "600",
                              color: "#2c3e50",
                              margin: "0",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.user_nicename}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              color: "#64748b",
                              fontSize: "0.85rem",
                            }}
                          >
                            {bodyTipoTemplate(item.tipo)}
                          </div>
                        </div>
                      </div>

                      {/* Detalhes do Agendamento */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr",
                          gap: "6px",
                          marginBottom: "5px",
                        }}
                      >
                        {/* Coluna 1 */}
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaUser
                              style={{ color: "#2980b9", fontSize: "0.75rem" }}
                            />{" "}
                            {/* Reduzido */}
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#2c3e50",
                                fontWeight: "500",
                              }}
                            >
                              {item.user_login}
                            </span>
                          </div>
                        </div>

                        {/* Coluna 2 */}
                        <div
                          style={{
                            display: "flex",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e8e8e8",
                            padding: "6px",
                            borderRadius: "6px",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <FaEnvelope
                              style={{ color: "#d35400", fontSize: "0.75rem" }}
                            />{" "}
                            {/* Reduzido */}
                            <span
                              style={{
                                fontSize: "0.8rem", // Reduzido
                                color: "#2c3e50",
                                fontWeight: "500",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.user_email}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Ações Secundárias */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingTop: "5px",
                          gap: "5px",
                          marginTop: "auto",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        {/* Ativo */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              fontFamily: "'Rajdhani', sans-serif",
                              gap: "6px",
                              padding: "2px 6px",
                              borderRadius: "12px",
                              fontSize: "0.75rem",
                              fontWeight: "500",
                              color: item.status === "ativo" ? "#27ae60" : "#e74c3c",
                            }}
                          >
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                backgroundColor:
                                  item.status === "ativo" ? "#27ae60" : "#e74c3c",
                              }}
                            />
                          </div>
                        </div>

                        {/* Botoes */}
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          <Button
                            icon="pi pi-file-edit"
                            onClick={() => {
                              setUsuarioEditando(item);

                              // Preenche os campos do formulário
                              setNome(item.user_nicename || "");
                              setEmail(item.user_email || "");
                              setLogin(item.user_login || "");
                              setTipo(item.tipo || "");
                              setAtivo(item.status?.toLowerCase() === "ativo");

                              // CORREÇÃO JÁ IMPLEMENTADA
                              if (
                                item.modulos &&
                                typeof item.modulos === "object"
                              ) {
                                const modulosInicial = {};
                                modulosDisponiveis.forEach((moduloObj) => {
                                  modulosInicial[moduloObj.nome] = {
                                    visualizar:
                                      item.modulos[moduloObj.nome]
                                        ?.visualizar || false,
                                    editar:
                                      item.modulos[moduloObj.nome]?.editar ||
                                      false,
                                  };
                                });
                                setModulosSelecionados(modulosInicial);
                              } else {
                                const modulosInicial = {};
                                modulosDisponiveis.forEach((moduloObj) => {
                                  modulosInicial[moduloObj.nome] = {
                                    visualizar: false,
                                    editar: false,
                                  };
                                });
                                setModulosSelecionados(modulosInicial);
                              }

                              setVisibleEditarUsuario(true);
                            }}
                            className="p-button-outlined p-button-sm"
                            style={{
                              outline: "none",
                              boxShadow: "none",
                              width: "25px",
                              height: "25px",
                              borderColor: "#dee2e6",
                              color: "#495057",
                            }}
                            tooltip="Editar"
                            tooltipOptions={{ position: "top" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Loading Spinner */}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="8"
          />
        </div>
      )}
    </div>
  );
};
export default Usuarios;
